'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isFunction = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _wendysKennyLoggins = require('wendys-kenny-loggins');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * passes any log message through a collection of provided filters, then passes 
 * the filtered result to an underlying wrapped appender.
 * This can be used for filtering sensitive information like credit card numbers 
 * before it is passed to the wrapped appender.
 */

var FilteringAppender = function (_BaseAppender) {
	_inherits(FilteringAppender, _BaseAppender);

	/**
  * filters require a doFilter method. If it is not present, the filter will be skipped.
  * 
  * @constructor
  * @param {object} appenderToWrap: if missing, will fail silently.
  * @param {Array} filtersArray: if empty/missing, will pass through to appender as-is.
     */
	function FilteringAppender(appenderToWrap, filtersArray) {
		_classCallCheck(this, FilteringAppender);

		var _this = _possibleConstructorReturn(this, (FilteringAppender.__proto__ || Object.getPrototypeOf(FilteringAppender)).call(this));

		_this.appender = appenderToWrap;
		_this.filtersArray = filtersArray;
		return _this;
	}

	/**
  * apply the filters and then pass to the wrapped appender
  * @param {object} message: js object to log
     */


	_createClass(FilteringAppender, [{
		key: 'doAppend',
		value: function doAppend(message) {
			if (!message || !(this.appender instanceof _wendysKennyLoggins.BaseAppender)) return;
			var filteredCopy = _.cloneDeep(message);
			if (Array.isArray(this.filtersArray)) {
				filteredCopy = this._applyFilters(filteredCopy);
			}
			if (filteredCopy) {
				var getType = {};
				if (isFunction(this.appender.doAppend)) {
					this.appender.doAppend(filteredCopy);
				} else if (isFunction(this.appender.append)) {
					this.appender.append(filteredCopy);
				}
			};
		}

		/**
   * apply each filter to the message.
   * @param {object} message: js object to log
   * @returns {object} fully filtered message
      * @private
      */

	}, {
		key: '_applyFilters',
		value: function _applyFilters(message) {
			for (var i = 0; i < this.filtersArray.length; i++) {
				var filter = this.filtersArray[i];
				//filters need a doFilter method
				if (!filter.doFilter) continue;
				message = filter.doFilter(message);
			}
			return message;
		}
	}]);

	return FilteringAppender;
}(_wendysKennyLoggins.BaseAppender);

exports.default = FilteringAppender;


function isFunction(funcToCheck) {
	var getType = {};
	return funcToCheck && getType.toString.call(funcToCheck) === '[object Function]';
}

exports.isFunction = isFunction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins-filtering-appender/lib/FilteringAppender.js
// module id = 891
// module chunks = 0